import React from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PageHeader, SectionCard, StatusBadge, CardSkeleton, EmptyState } from "@/admin/ui";

export default function AdminProducts() {
  const [products, setProducts] = React.useState(null);
  const load = () => api.get("/api/admin/products").then((r) => setProducts(r.data.items));
  React.useEffect(() => { load(); }, []);
  const toggle = async (p, field) => {
    try { await api.put(`/api/admin/products/${p.id}`, { [field]: !p[field] }); toast.success("Updated"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  return (
    <div className="space-y-6" data-testid="admin-products-page">
      <PageHeader title="Products (legacy)" description="Toggle active/inactive, enable maintenance mode. For versioned catalog management use Products V2."
        badge={<StatusBadge tone="neutral">Legacy</StatusBadge>} />
      {!products ? <CardSkeleton h="h-40" /> : products.length === 0 ? (
        <EmptyState title="No legacy products" />
      ) : (
        <div className="grid gap-3">
          {products.map((p) => (
            <SectionCard key={p.id} testid={`admin-product-${p.slug}`}
              title={<span className="flex items-center gap-2 flex-wrap">{p.name} <StatusBadge tone="brand">{p.category}</StatusBadge></span>}
              description={<span>{p.slug} · base <span className="font-mono">{p.base_path}</span></span>}
              right={<div className="flex items-center gap-2 flex-wrap">
                <button className="focus:outline-none" onClick={() => toggle(p, "active")} data-testid={`toggle-active-${p.slug}`}>
                  <StatusBadge tone={p.active ? "success" : "danger"}>{p.active ? "active" : "inactive"}</StatusBadge>
                </button>
                <button className="focus:outline-none" onClick={() => toggle(p, "maintenance")} data-testid={`toggle-maint-${p.slug}`}>
                  <StatusBadge tone={p.maintenance ? "warning" : "neutral"}>{p.maintenance ? "maintenance" : "normal"}</StatusBadge>
                </button>
              </div>} />
          ))}
        </div>
      )}
    </div>
  );
}
